<template>
  <div class="inventory">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="时间范围" label-width="70px">
        <el-date-picker
            @input="search"
            v-model="searchForm.dayTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            style="width: 220px"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="代理商" label-width="60px">
        <DicInput @fieldId="fieldId($event,'operatorId')" :initName="searchForm.operatorId" :dicType="6"></DicInput>
      </el-form-item>
      <el-form-item label="药房" label-width="60px">
        <DicInput @fieldId="fieldId($event,'pharmacyId')" :initName="searchForm.pharmacyId" :dicType="8"></DicInput>
      </el-form-item>
      <el-form-item label="设备型号" label-width="80px">
        <DicInput @fieldId="fieldId($event,'deviceType')" :initName="searchForm.deviceType" :dicType="1"></DicInput>
      </el-form-item>
      <el-form-item label="异常类型" >
        <DicInput @fieldId="fieldId($event,'exceptionType')" :initName="searchForm.exceptionType" :dicType="4"></DicInput>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%">
        <el-table-column
            prop="itemName"
            min-width="70"
            label="统计项目名称">
        </el-table-column>
        <el-table-column
            prop="count"
            min-width="70"
            label="数量">
        </el-table-column>
      </el-table>
    </div>
<!--    &lt;!&ndash; 分页 &ndash;&gt;-->
<!--    <div style="margin-top: 20px">-->
<!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
<!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
<!--    </div>-->
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from "@/components/DicInput";
export default {
  name: "inventory",
  data() {
    return {
      tableData: [],
      searchForm: {
        dayTime:[]
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear(){
      this.searchForm={
        dayTime:[],
        operatorId:'',
        pharmacyId:'',
        deviceType:'',
        exceptionType:'',
      }
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    fieldId(item,name){
      if(item.id){
        this.searchForm[name]=item.id
      }else {
        this.searchForm[name]=''
      }
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        start: this.searchForm.dayTime[0],
        end: this.searchForm.dayTime[1],
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("/Statistics/PFExceptionDealStatistic/GetExceptionStatisticByExceptionType", {params: data})
          .then((res) => {
            this.tableData = res
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
    this.operatorList()
  }
}
</script>

<style lang="scss" scoped>
.inventory {

}
</style>